import { render } from 'solid-js/web';
import { documentReady, findElementById } from '../Utils';
import { CityBreakWidget } from './CityBreakWidget';

documentReady(() => {
    const $widget = findElementById('cityBreakCalendarWidget');

    // Init CityBreak Calendar
    if ($widget != null) {
        render(() => <CityBreakWidget />, $widget);
    }
});
